import { Container, SimpleGrid, Title  } from '@mantine/core';

import AccordionWithFilter from '../CustomComponents/AccordionWithFilter';

const Reportes = () => {
  //for spacing the skelleton  
  return (
    <>
      <Container
        fluid
        p="md"
        style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginRight: '20px'
        }}
      >
        <Title order={1} style={{ marginBottom: 20 }}>Ejecución Reportes</Title>

        <SimpleGrid cols={{ base: 1, xs: 4 }} style={{ flex: 1 }} spacing="md">          

          <AccordionWithFilter/>
          
        </SimpleGrid>
      </Container>
    </>

  );

}

export default Reportes;